import img1 from "../images/vefa/img1.jpg";

export const imgVefa = [
  {
    id: 3101,
    image: img1
  }
];